import {useApiRequest} from './hook';
import {CustomNotificationData} from '@integraciones_doc24/wehealthy-api/types/notification/custom';
import {sendCustomNotificationEndpoint} from '@integraciones_doc24/wehealthy-api/root/notification/sendCustomNotification';
import {tag} from '../types/general-types';

export const useSendCustomNotification = () => {
  const request = useApiRequest(sendCustomNotificationEndpoint);
  return async (
    content: CustomNotificationData,
    notification: 'ALL' | 'TAG',
    tags: tag[],
  ) => {
    const response = await request({
      body: {
        ...content,
        tags,
        notification,
      },
    });
    return response.data;
  };
};
